import React from "react";
import { Box } from "@mui/material";
import { DBComponente } from "../../../../interfaces/SuperAdmin/Others/iDataComponentes";
import AppsSection from "./AppsSection";
import UsersSection from "./UsersSection";
import { iDataUser } from "../../../../interfaces/SuperAdmin/Pages/iDataUser";

interface SelectAppsAndUsersProps {
  apps: DBComponente[];
  allUsers: iDataUser[];
  selectedApps: string[];
  selectedUsers: string[];
  isCreating: boolean;
  setSelectedApps: React.Dispatch<React.SetStateAction<string[]>>;
  setSelectedUsers: React.Dispatch<React.SetStateAction<string[]>>;
}

const SelectAppsAndUsers: React.FC<SelectAppsAndUsersProps> = ({
  apps,
  allUsers,
  selectedApps,
  selectedUsers,
  isCreating,
  setSelectedApps,
  setSelectedUsers,
}) => {
  return (
    <Box sx={{ display: "flex", gap: 2, width: 1 }}>
      {/* Apps Section */}
      <AppsSection
        apps={apps}
        setSelectedApps={setSelectedApps}
        isCreating={isCreating}
        selectedApps={selectedApps}
      />

      {/* Users Section */}
      <UsersSection
        allUsers={allUsers}
        setSelectedUsers={setSelectedUsers}
        isCreating={isCreating}
        selectedUsers={selectedUsers}
      />
    </Box>
  );
};

export default SelectAppsAndUsers;
